import { Button, Card, Div, HeightAnimation, P, Space } from '@dnb/eufemia';
import classnames from 'classnames';
import { type ReactNode, useState } from 'react';

import NoData from '../NoData';

import style from './index.module.css';

interface ExpandableCardProps {
  nodes: ReactNode[];
  title: string | ReactNode;
  wrapLimit: number;
  emptyNodesText: string;
  warning?: ReactNode;
}

export function ExpandableCard({ nodes, title, wrapLimit, emptyNodesText, warning }: ExpandableCardProps) {
  const [isOpen, setIsOpen] = useState(false);
  const chunk1 = nodes.length > wrapLimit ? nodes.slice(0, wrapLimit) : nodes;
  const chunk2 = nodes.length > wrapLimit ? nodes.slice(wrapLimit) : null;
  const isString = typeof title === 'string';

  return (
    <Card stack>
      {isString ? <P weight="medium">{title}</P> : title}
      {warning && <Space>{warning}</Space>}
      {chunk1.length > 0 ? (
        <Div>
          <Div className={style['List']}>{chunk1}</Div>
          {chunk2 && (
            <HeightAnimation open={isOpen}>
              <Div className={classnames(style['List'], style['PaddingTop'])}>{chunk2}</Div>
            </HeightAnimation>
          )}
        </Div>
      ) : (
        <NoData message={emptyNodesText} />
      )}
      {chunk2 && (
        <Button
          className={style['ExpandButton']}
          icon={isOpen ? 'chevron-up' : 'chevron-down'}
          onClick={() => setIsOpen(!isOpen)}
          variant="secondary"
        >
          {isOpen ? 'Close' : `Show ${nodes.length - wrapLimit} more`}
        </Button>
      )}
    </Card>
  );
}
